export const REQUIRED_MESSAGE = "This field is required";
export const REQUIRED_FOR_COMPLIANCE_MESSAGE =
  "This field is required for compliance samples";
